import { __assign as o } from "../../_virtual/_tslib.js";
import r from "../component.js";
import t from "../common/visible.js";

function n(n, m) {
  var i = r(o(o({}, n), {
    add: function add(o, r) {
      o.addControl(r);
    },
    remove: function remove(o, r) {
      o.removeControl(r);
    }
  }), m);
  return t(i, m), i;
}

export { n as useControl };